// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] + "." + {"440":"08677872","581":"38358be3"}[chunkId] + ".chunk.js";
};